"use client";

import { ImageCard } from "@jesus-central-church/ui";
import {
  SbBlokData,
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import { SbImageCard } from "@storyblok/types/287435740670216/storyblok-components";

export function ImageCardComponent({
  blok,
  pageData,
}: {
  blok: SbImageCard;
  pageData: { locale: string };
}) {
  return (
    <ImageCard
      image={
        blok.image?.filename
          ? {
              src: blok.image.filename,
              alt: blok.image.alt || blok.title || "Card image",
            }
          : undefined
      }
      title={blok.title}
      description={blok.description}
      backgroundColor={blok.backgroundColor as string}
      textColor={
        blok.textColor as
          | "boldness"
          | "freedom"
          | "strategy-red"
          | "strategy-gold"
          | "strategy-green"
      }
      actions={
        blok.actions && blok.actions.length > 0
          ? blok.actions.map((action) => (
              <StoryblokServerComponent
                key={action._uid}
                blok={action}
                pageData={pageData}
              />
            ))
          : undefined
      }
      {...storyblokEditable(blok as SbBlokData)}
    />
  );
}
